import { handleActions } from 'redux-actions';
import { defaultBrowsingModeWidgetState } from './defaults';
import { BrowsingModeWidgetData } from './types';
import { initBrowsingPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  INITIAL_SAVE_REQUEST_META,
  saveableWidgetRequestMetaReducer,
} from '../utils';
import {
  setBrowsingModeWidgetContentFilter,
  saveBrowsingMode,
  saveBrowsingModeSuccess,
  saveBrowsingModeFailure,
} from './actions';

const mergeBrowsingModeWidgetDataChange = makeSpecificSaveableWidgetDataMergeFunction(
  defaultBrowsingModeWidgetState
);

export default handleActions<BrowsingModeWidgetData, any>(
  {
    [initBrowsingPage.toString()]: (state, action: ReturnType<typeof initBrowsingPage>) => {
      const data: BrowsingModeWidgetData['initialData'] = {
        contentFilter: action.payload.data.contentFilter,
        contentFilterList: action.payload.data.contentFilterList,
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setBrowsingModeWidgetContentFilter.toString()]: (
      state,
      action: ReturnType<typeof setBrowsingModeWidgetContentFilter>
    ) =>
      mergeBrowsingModeWidgetDataChange(state, {
        contentFilter: action.payload.contentFilter as 'standard' | 'mature' | 'safe',
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveBrowsingMode,
      successAction: saveBrowsingModeSuccess,
      failureAction: saveBrowsingModeFailure,
    }),
  },
  defaultBrowsingModeWidgetState
);
